import { BILL_STATUS } from "constants/vendorBills";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { stringify } from "qs";
import { AccountsPayableData } from "store/apis/financialMetrics";
import {
  AccountsCard,
  AccountsCardContent,
  TableRowData,
} from "./AccountsAnalysisCard";

type AccountsPayableProps = {
  data?: AccountsPayableData;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  forcedTab?: "vendors" | "bills";
  isExport?: boolean;
};

export const AccountsPayable = ({
  data,
  isLoading,
  isSuccess,
  isError,
  forcedTab,
  isExport,
}: AccountsPayableProps) => {
  const { link } = useConstructInternalLink();

  const vendorRows: TableRowData[] =
    data?.top_vendors.map((vendor) => ({
      uuid: vendor.uuid,
      label: vendor.name,
      amount: vendor.amount,
      link: link(`/books/expenses/vendors/${vendor.uuid}`),
    })) ?? [];

  const billRows: TableRowData[] =
    data?.top_bills.map((bill) => ({
      uuid: bill.uuid,
      label: bill.bill_number,
      amount: bill.amount,
      link: link(`/books/bills-and-vendors/bill/${bill.uuid}`),
    })) ?? [];

  const pendingStatuses = [BILL_STATUS.DUE, BILL_STATUS.OVERDUE].join(",");

  const billsViewAllUrl = `${link("/books/bills-and-vendors")}&${stringify({
    STATUS: pendingStatuses,
  })}`;

  return (
    <AccountsCard
      title="Accounts Payable (AP)"
      loadingText="Loading AP Analysis..."
      emptyTitle="No outstanding Payables"
      emptySubtitle="Add bills to track Accounts Payable"
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      isEmpty={data?.total_outstanding === 0}
    >
      {data && (
        <>
          <AccountsCardContent
            defaultTab="vendors"
            totalOutstanding={data.total_outstanding}
            forcedTab={forcedTab}
            isExport={isExport}
            tabs={[
              {
                value: "vendors",
                label: "Vendors",
                columnHeader: "Vendor",
                rows: vendorRows,
                viewAllUrl: link("/books/expenses/vendors"),
                viewAllText: "View all Vendors",
              },
              {
                value: "bills",
                label: "Bills",
                columnHeader: "Bill",
                rows: billRows,
                viewAllUrl: billsViewAllUrl,
                viewAllText: "View all pending bills",
              },
            ]}
          />
        </>
      )}
    </AccountsCard>
  );
};
